module.exports = __webpack_public_path__ + "static/media-grid-4ce73d368f24dbfc8e08865b734d78ee.png";